import React from 'react';
import { Modal } from '@abyss/web/ui/Modal';
import { useOverlay } from '@abyss/web/hooks/useOverlay';
import { Grid } from '@abyss/web/ui/Grid';
import { V2Text } from '@abyss/web/ui/Text';
import { V2TextInput } from '@abyss/web/ui/TextInput';
import { V2FormProvider } from '@abyss/web/ui/FormProvider';
import { useFormV2 } from '@abyss/web/hooks/useForm';

export const SURVEY_MODAL_ID = 'survey-response-modal';

const QUESTIONS = [
  {
    model: 'question1',
    label:
      'Reflecting on your recent technology experience at UnitedHealth Group, how satisfied are you with your overall experience?',
  },
  {
    model: 'question2',
    label:
      'Have you encountered any challenges with our technology, software, or applications that you have not chosen to report in the past three months?',
  },
  {
    model: 'question3',
    label:
      'Do you feel your technology experience has improved, declined, or remained consistent? Please explain why.',
  },
  {
    model: 'question4',
    label:
      'If you had an opportunity to share anything with your technology partners, what would it be?',
  },
  {
    model: 'question5',
    label:
      'Can a technology team member follow up with you regarding your response?',
  },
];

type SurveyResponseModalProps = {
  answers: Record<string, string>;
  sourceSessionId: number | string;
};

export const SurveyResponseModal = ({
  answers,
  sourceSessionId,
}: SurveyResponseModalProps) => {
  const modalOverlay = useOverlay(SURVEY_MODAL_ID);

  const form = useFormV2({
    defaultValues: answers,
    values: answers,
  });

  return (
    <Modal
      model={SURVEY_MODAL_ID}
      size="lg"
      title={`Survey Response: ${sourceSessionId}`}
      titleAlign="left"
      onClose={() => modalOverlay.close()}
    >
      <Modal.Section>
        <V2FormProvider state={form}>
          <Grid css={{ padding: '$lg' }}>
            {QUESTIONS.map(({ model, label }) => (
              <Grid.Col span={12} key={model} css={{ paddingBottom: '$md' }}>
                <V2Text fontWeight="bold" css={{ marginBottom: '$sm' }}>
                  {label}
                </V2Text>
                <V2TextInput label="" model={model} isDisabled />
              </Grid.Col>
            ))}
          </Grid>
        </V2FormProvider>
      </Modal.Section>
    </Modal>
  );
};
